import useTranslate from "@/hooks/useTranslate/useTranslate";

import type { I_UseValidate_Return } from "../index";

export default function idnpValidator(value: string): I_UseValidate_Return {
    if (!value) {
        return {
            status: false,
            message: useTranslate("tiw__validation__required"),
        };
    }

    if (!/^\d{13}$/.test(value)) {
        return {
            status: false,
            message: useTranslate("tiw__validation__idnp_range_md"),
        };
    }

    return {
        status: true,
        message: useTranslate("tiw__validation__success"),
    };
}
